export default "__VITE_ASSET__D5SlqxGW__"